import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { PortalRole } from '../types/portalUser';
import { peekAccountDeactivatedLogout } from '../utils/portalSession';

interface PrivateRouteProps {
  children: React.ReactNode;
  allowedRoles?: PortalRole[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, allowedRoles }) => {
  const { user, loading, hasRole, defaultPath } = useAuth();

  if (loading) return null;

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={peekAccountDeactivatedLogout() ? { accountDeactivated: true } : undefined}
      />
    );
  }

  if (!hasRole(allowedRoles)) {
    return <Navigate to={defaultPath} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
